import { render, staticRenderFns } from "./Processadores.vue?vue&type=template&id=38c4e50f&"
import script from "./Processadores.vue?vue&type=script&lang=ts&"
export * from "./Processadores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports